import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=3e8fc9e2&scoped=true&"
import script from "./TermsPage.vue?vue&type=script&lang=js&"
export * from "./TermsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8fc9e2",
  null
  
)

export default component.exports